import React from 'react';
import match from 'static/img/home/benefits/match.svg';
import education from 'static/img/home/benefits/education.svg';
import noHiddenFee from 'static/img/home/benefits/no-hidden-fee.svg';
import starIcon from 'static/img/home/benefits/star.svg';

interface ITutorBenefit {
  img: string;
  title: string;
  description: string | React.ReactNode;
}

export const tutorBenefits: ITutorBenefit[] = [
  {
    img: education,
    title: 'Trained & Experienced',
    description:
     <span>We train our online tutors to be more than just teachers. <b>Our training and interview process</b> ensures students get experienced tuition and the educational support they deserve. All tutors are background checked.</span>
  },
  {
    img: match,
    title: 'Free First Lesson',
    description:
      <span>Tutor House offers a <b>FREE 30-minute trial lesson</b> with a tutor. This means you get to see if they’re right for you before committing. Once you've had your free call you'll have the option to book discounted package lessons.</span>
  },
  {
    img: starIcon,
    title: 'Interactive Lessons',
    description:
      'With Tutor House you get access to our learning platform, which has a number of great features including: recording your lesson, using the interactive whiteboard, video and audio and file sharing capabilities.'
  },
  {
    img: noHiddenFee,
    title: 'No hidden fees',
    description:
    <span>With Tutor House, you’ll never pay for anything other than the tuition sessions that you receive! <b>Become a member and you will save up to 20% on all lessons.</b> We also offer a 100% money-back guarantee.</span>
  },
];
